package com.appsyde.shared.modules.ai.domain.usecase


 import com.appsyde.shared.modules.ai.domain.model.AiRefineAction
 import com.appsyde.shared.modules.ai.domain.repository.AiRepositoryV2

class RefineTextUseCaseV2(
    private val aiRepositoryV2: AiRepositoryV2
) {

    suspend operator fun invoke(
        action: AiRefineAction,
        text: String
    ): String {
        val input = text.trim()
        if (input.isBlank()) return ""

        return aiRepositoryV2.refineText(
            action = action,
            text = input
        ).trim()
    }
}
